import React, { useState, useEffect } from 'react';

const KLUBOVI = ['KK Rad', 'KK Rad 2', 'ŽKK Olimp'];
const SEZONE = ['2025/2026', '2026/2027'];
const TAKMICENJA = ['Premijer liga', 'Prva liga RS', 'Kup RS', 'Kup BiH'];

function Utakmice({ igraci, utakmice, sacuvajUtakmicu, obrisiUtakmicu, setAktivna, otvoriUnos, predUnos, globalnaSezona, jeAdmin, jeGost }) {
  const [prikaz, setPrikaz] = useState((otvoriUnos || predUnos) && jeAdmin ? 'unos' : 'lista');
  const [filterSezona, setFilterSezona] = useState(globalnaSezona || '2025/2026');
  useEffect(() => { setFilterSezona(globalnaSezona); }, [globalnaSezona]);
  const [filterKlub, setFilterKlub] = useState('svi');
  const [forma, setForma] = useState({
    datum: predUnos?.datum || new Date().toISOString().split('T')[0],
    kolo: predUnos?.kolo || '',
    sezona: predUnos?.sezona || globalnaSezona || '2025/2026',
    klub: predUnos?.klub || KLUBOVI[0],
    protivnik: predUnos?.protivnik || '',
    domaci: predUnos?.domaci ?? true,
    protivnikCunjevi: '',
    takmicenje: predUnos?.takmicenje || 'Premijer liga',
  });
  const [odabraniIgraci, setOdabraniIgraci] = useState([]);
  const [izmjene, setIzmjene] = useState([]);
  const [rezultati, setRezultati] = useState({});
  const [naprednaPodesavanja, setNaprednaPodesavanja] = useState({});
  const [korak, setKorak] = useState(1);

  const igraciKluba = igraci.filter(i => i.klub === forma.klub);

  const isUlazniIgrac = (igracId) => !!izmjene.find(iz => iz.igracUnutra === igracId);

  const filtrirane = utakmice
    .filter(u => u.sezona === filterSezona)
    .filter(u => filterKlub === 'svi' || u.klub === filterKlub)
    .sort((a, b) => b.datum?.localeCompare(a.datum));

  const toggleIgrac = (igrac) => {
    setOdabraniIgraci(prev => {
      const postoji = prev.find(i => i.id === igrac.id);
      if (postoji) return prev.filter(i => i.id !== igrac.id);
      if (prev.length >= 6) { alert('Maksimalno 6 igraca!'); return prev; }
      return [...prev, igrac];
    });
  };

  const dodajIzmjenu = () => {
    if (izmjene.length >= 2) { alert('Maksimalno 2 izmjene!'); return; }
    setIzmjene(prev => [...prev, { id: Date.now(), igracVani: '', igracUnutra: '', ukupnoHitac: '' }]);
  };

  const updateIzmjena = (id, polje, vrijednost) => {
    setIzmjene(prev => prev.map(iz => iz.id === id ? { ...iz, [polje]: vrijednost } : iz));
  };

  const sviIgraciUtakmice = () => {
    const lista = [...odabraniIgraci];
    izmjene.forEach(iz => {
      if (iz.igracUnutra) {
        const igrac = igraciKluba.find(i => i.id === iz.igracUnutra);
        if (igrac && !lista.find(i => i.id === igrac.id)) lista.push(igrac);
      }
    });
    return lista;
  };

  const toggleNapredna = (igracId) => {
    setNaprednaPodesavanja(prev => ({ ...prev, [igracId]: !prev[igracId] }));
  };

  const updateRezultat = (igracId, set, polje, vrijednost) => {
    setRezultati(prev => ({
      ...prev,
      [igracId]: { ...prev[igracId], [set]: { ...prev[igracId]?.[set], [polje]: vrijednost } }
    }));
  };

  const updateMP = (igracId, vrijednost) => {
    setRezultati(prev => ({ ...prev, [igracId]: { ...prev[igracId], mp: vrijednost } }));
  };

  const getSetoviZaIgraca = (igracId) => {
    const izmjenaVani = izmjene.find(iz => iz.igracVani === igracId);
    const izmjenaUnutra = izmjene.find(iz => iz.igracUnutra === igracId);

    if (izmjenaVani) {
      const hitac = parseInt(izmjenaVani.ukupnoHitac) || 1;
      const kugleBacene = hitac - 1;
      const zadnjiSet = kugleBacene === 0 ? 1 : Math.min(Math.ceil(kugleBacene / 30), 4);
      return { tip: 'izlaz', setOd: 1, setDo: zadnjiSet, ukupnoHitac: hitac };
    } else if (izmjenaUnutra) {
      const hitac = parseInt(izmjenaUnutra.ukupnoHitac) || 1;
      const prviSet = Math.min(Math.ceil(hitac / 30), 4);
      return { tip: 'ulaz', setOd: prviSet, setDo: 4, ukupnoHitac: hitac };
    }
    return { tip: 'cijeli', setOd: 1, setDo: 4 };
  };

  const izracunajIgraca = (igracId) => {
    const r = rezultati[igracId] || {};
    const napredna = naprednaPodesavanja[igracId] || isUlazniIgrac(igracId);
    const setInfo = getSetoviZaIgraca(igracId);

    if (napredna) {
      let ukupnoPune = 0, ukupnoCis = 0, ukupno = 0, sp = 0, promasaji = 0;
      for (let s = setInfo.setOd; s <= setInfo.setDo; s++) {
        const set = r[s] || {};
        const pune = parseFloat(set.pune) || 0;
        const cis = parseFloat(set.cis) || 0;
        ukupnoPune += pune;
        ukupnoCis += cis;
        ukupno += pune + cis;
        sp += parseFloat(set.sp) || 0;
        promasaji += parseFloat(set.promasaji) || 0;
      }
      return { ukupnoPune, ukupnoCis, ukupno, sp, mp: parseFloat(r.mp) || 0, promasaji };
    } else {
      const ukupnoPune = parseFloat(r.ukupnoPune) || 0;
      const ukupnoCis = parseFloat(r.ukupnoCis) || 0;
      return {
        ukupnoPune, ukupnoCis,
        ukupno: ukupnoPune + ukupnoCis,
        sp: parseFloat(r.sp) || 0,
        mp: parseFloat(r.mp) || 0,
        promasaji: parseFloat(r.promasajiOsnovni) || 0,
      };
    }
  };

  const izracunajEkipu = () => {
    let ukupno = 0, sp = 0, mp = 0, promasaji = 0;
    sviIgraciUtakmice().forEach(igrac => {
      const s = izracunajIgraca(igrac.id);
      ukupno += s.ukupno;
      sp += s.sp;
      mp += s.mp;
      promasaji += s.promasaji;
    });
    const protivnikCunjeviInt = parseFloat(forma.protivnikCunjevi) || 0;
    const bonusMP = protivnikCunjeviInt > 0
      ? (ukupno > protivnikCunjeviInt ? 2 : ukupno < protivnikCunjeviInt ? 0 : 1)
      : 0;
    const ukupnoMP = mp + bonusMP;
    const protivnikMP = 8 - ukupnoMP;
    let bodovi = 0;
    if (ukupnoMP > protivnikMP) bodovi = 2;
    else if (ukupnoMP === protivnikMP) bodovi = 1;
    else bodovi = 0;
    return { ukupno, sp, mp, promasaji, bodovi, protivnikCunjevi: protivnikCunjeviInt, mpProtivnik: protivnikMP, ukupnoMP, bonusMP };
  };

  const resetForma = () => {
    setForma({
      datum: new Date().toISOString().split('T')[0],
      kolo: '', sezona: globalnaSezona || '2025/2026',
      klub: KLUBOVI[0], protivnik: '', domaci: true, protivnikCunjevi: '',
    takmicenje: 'Premijer liga',
    });
    setOdabraniIgraci([]);
    setIzmjene([]);
    setRezultati({});
    setNaprednaPodesavanja({});
    setKorak(1);
    setPrikaz('lista');
  };

  const handleSacuvaj = async () => {
    if (!forma.kolo) return alert('Upisi broj kola!');
    if (!forma.protivnik) return alert('Upisi naziv protivnika!');
    if (odabraniIgraci.length === 0) return alert('Odaberi igrace!');

    const rezultatiZaBazu = sviIgraciUtakmice().map(igrac => {
      const s = izracunajIgraca(igrac.id);
      const r = rezultati[igrac.id] || {};
      const napredna = naprednaPodesavanja[igrac.id] || isUlazniIgrac(igrac.id);
      const setInfo = getSetoviZaIgraca(igrac.id);
      const izmjenaVani = izmjene.find(iz => iz.igracVani === igrac.id);
      const izmjenaUnutra = izmjene.find(iz => iz.igracUnutra === igrac.id);

      let izmjenaInfo = null;
      if (izmjenaVani) {
        izmjenaInfo = { tip: 'izlaz', ukupnoHitac: parseInt(izmjenaVani.ukupnoHitac) || 1 };
      } else if (izmjenaUnutra) {
        izmjenaInfo = { tip: 'ulaz', ukupnoHitac: parseInt(izmjenaUnutra.ukupnoHitac) || 1 };
      }

      return {
        igracId: igrac.id, ime: igrac.ime,
        osnovni: !!odabraniIgraci.find(i => i.id === igrac.id),
        napredna: !!napredna, izmjena: izmjenaInfo,
        set1: napredna && setInfo.setOd <= 1 && setInfo.setDo >= 1 ? { pune: parseFloat(r[1]?.pune) || 0, cis: parseFloat(r[1]?.cis) || 0, sp: parseFloat(r[1]?.sp) || 0, promasaji: parseFloat(r[1]?.promasaji) || 0 } : {},
        set2: napredna && setInfo.setOd <= 2 && setInfo.setDo >= 2 ? { pune: parseFloat(r[2]?.pune) || 0, cis: parseFloat(r[2]?.cis) || 0, sp: parseFloat(r[2]?.sp) || 0, promasaji: parseFloat(r[2]?.promasaji) || 0 } : {},
        set3: napredna && setInfo.setOd <= 3 && setInfo.setDo >= 3 ? { pune: parseFloat(r[3]?.pune) || 0, cis: parseFloat(r[3]?.cis) || 0, sp: parseFloat(r[3]?.sp) || 0, promasaji: parseFloat(r[3]?.promasaji) || 0 } : {},
        set4: napredna && setInfo.setOd <= 4 && setInfo.setDo >= 4 ? { pune: parseFloat(r[4]?.pune) || 0, cis: parseFloat(r[4]?.cis) || 0, sp: parseFloat(r[4]?.sp) || 0, promasaji: parseFloat(r[4]?.promasaji) || 0 } : {},
        ukupnoPune: s.ukupnoPune, ukupnoCis: s.ukupnoCis, ukupno: s.ukupno,
        sp: s.sp, mp: s.mp, promasaji: s.promasaji,
      };
    });

    const ekipa = izracunajEkipu();
    await sacuvajUtakmicu({
      datum: forma.datum, kolo: parseInt(forma.kolo), sezona: forma.sezona,
      klub: forma.klub, protivnik: forma.protivnik, domaci: forma.domaci, takmicenje: forma.takmicenje || 'Premijer liga',
      protivnikCunjevi: ekipa.protivnikCunjevi, rezultati: rezultatiZaBazu, izmjene,
      ekipaUkupno: ekipa.ukupno, ekipaSP: ekipa.sp, ekipaMP: ekipa.ukupnoMP,
      ekipaPromasaji: ekipa.promasaji, ekipaBodovi: ekipa.bodovi,
      protivnikMP: ekipa.mpProtivnik, bonusMP: ekipa.bonusMP,
    });
    resetForma();
  };

  const ekipa = izracunajEkipu();

  const renderFormaIgraca = (igrac) => {
    const ulazni = isUlazniIgrac(igrac.id);
    const napredna = naprednaPodesavanja[igrac.id] || ulazni;
    const r = rezultati[igrac.id] || {};
    const stat = izracunajIgraca(igrac.id);
    const setInfo = getSetoviZaIgraca(igrac.id);
    const setoviZaPrikaz = [];
    for (let s = setInfo.setOd; s <= setInfo.setDo; s++) setoviZaPrikaz.push(s);

    const setLabel = (s) => {
      if (setInfo.tip === 'izlaz' && s === setInfo.setDo) return 'Set ' + s + ' (do hitca ' + (setInfo.ukupnoHitac - 1) + ')';
      if (setInfo.tip === 'ulaz' && s === setInfo.setOd) return 'Set ' + s + ' (od hitca ' + setInfo.ukupnoHitac + ')';
      return 'Set ' + s;
    };

    return (
      <div key={igrac.id} style={{ background: '#16162a', border: '1px solid #2a2a4a', borderRadius: '10px', padding: '14px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <div>
            <div style={{ fontWeight: '600', color: '#fff', fontSize: '14px' }}>{igrac.ime}</div>
            {setInfo.tip === 'izlaz' && (
              <div style={{ fontSize: '11px', color: '#e94560', marginTop: '2px' }}>
                ↑ Izlazi na hitcu {setInfo.ukupnoHitac} — bacio {setInfo.ukupnoHitac - 1} kugli
              </div>
            )}
            {setInfo.tip === 'ulaz' && (
              <div style={{ fontSize: '11px', color: '#2ed573', marginTop: '2px' }}>
                ↓ Ulazi na hitcu {setInfo.ukupnoHitac} — baca {120 - (setInfo.ukupnoHitac - 1)} kugli
              </div>
            )}
            {setInfo.tip === 'cijeli' && (
              <div style={{ fontSize: '11px', color: '#666688', marginTop: '2px' }}>Igra svih 120 hitaca</div>
            )}
          </div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {stat.ukupno > 0 && <span className="badge badge-red">{stat.ukupno} cunjeva</span>}
            {ulazni ? (
              <span style={{ padding: '4px 12px', fontSize: '12px', borderRadius: '6px', background: '#1a2a1a', color: '#2ed573', border: '1px solid #2ed573' }}>
                Po setovima (izmjena)
              </span>
            ) : (
              <button onClick={() => toggleNapredna(igrac.id)}
                style={{ padding: '4px 12px', fontSize: '12px', borderRadius: '6px', background: napredna ? '#e94560' : '#12122a', color: napredna ? 'white' : '#888899', border: '1px solid #2a2a4a', cursor: 'pointer' }}>
                {napredna ? 'Osnovno' : 'Napredno (po setovima)'}
              </button>
            )}
          </div>
        </div>

        {!napredna && (
          <div className="form-row">
            <div className="form-group">
              <label>Pune (ukupno)</label>
              <input type="number" min="0" step="0.5" value={r.ukupnoPune || ''}
                onChange={e => setRezultati(prev => ({ ...prev, [igrac.id]: { ...prev[igrac.id], ukupnoPune: e.target.value } }))}
                style={{ width: '90px' }} />
            </div>
            <div className="form-group">
              <label>Ciscenje (ukupno)</label>
              <input type="number" min="0" step="0.5" value={r.ukupnoCis || ''}
                onChange={e => setRezultati(prev => ({ ...prev, [igrac.id]: { ...prev[igrac.id], ukupnoCis: e.target.value } }))}
                style={{ width: '90px' }} />
            </div>
            <div className="form-group">
              <label>Promasaji</label>
              <input type="number" min="0" step="1" value={r.promasajiOsnovni || ''}
                onChange={e => setRezultati(prev => ({ ...prev, [igrac.id]: { ...prev[igrac.id], promasajiOsnovni: e.target.value } }))}
                style={{ width: '80px' }} />
            </div>
            <div className="form-group">
              <label>SP</label>
              <input type="number" min="0" max="6" step="0.5" value={r.sp || ''}
                onChange={e => setRezultati(prev => ({ ...prev, [igrac.id]: { ...prev[igrac.id], sp: e.target.value } }))}
                style={{ width: '70px' }} />
            </div>
            <div className="form-group">
              <label>MP</label>
              <input type="number" min="0" max="1" step="0.5" value={r.mp || ''}
                onChange={e => updateMP(igrac.id, e.target.value)}
                style={{ width: '70px' }} />
            </div>
            {stat.ukupno > 0 && (
              <div className="form-group">
                <label>Prosjek/set</label>
                <div style={{ padding: '9px 0', fontSize: '18px', fontWeight: '700', color: '#e94560' }}>
                  {Math.round(stat.ukupno / setoviZaPrikaz.length)}
                </div>
              </div>
            )}
          </div>
        )}

        {napredna && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ minWidth: '580px', marginBottom: '10px' }}>
              <thead>
                <tr>
                  <th>Set</th>
                  <th style={{ textAlign: 'center' }}>Pune</th>
                  <th style={{ textAlign: 'center' }}>Ciscenje</th>
                  <th style={{ textAlign: 'center' }}>Promasaji</th>
                  <th style={{ textAlign: 'center' }}>SP</th>
                  <th style={{ textAlign: 'center' }}>Ukupno</th>
                </tr>
              </thead>
              <tbody>
                {setoviZaPrikaz.map(s => {
                  const set = r[s] || {};
                  const pune = parseFloat(set.pune) || 0;
                  const cis = parseFloat(set.cis) || 0;
                  return (
                    <tr key={s}>
                      <td style={{ color: '#e94560', fontWeight: '600' }}>{setLabel(s)}</td>
                      <td style={{ padding: '4px', textAlign: 'center' }}>
                        <input type="number" min="0" step="0.5" value={set.pune || ''}
                          onChange={e => updateRezultat(igrac.id, s, 'pune', e.target.value)}
                          style={{ width: '55px', textAlign: 'center' }} />
                      </td>
                      <td style={{ padding: '4px', textAlign: 'center' }}>
                        <input type="number" min="0" step="0.5" value={set.cis || ''}
                          onChange={e => updateRezultat(igrac.id, s, 'cis', e.target.value)}
                          style={{ width: '55px', textAlign: 'center' }} />
                      </td>
                      <td style={{ padding: '4px', textAlign: 'center' }}>
                        <input type="number" min="0" step="1" value={set.promasaji || ''}
                          onChange={e => updateRezultat(igrac.id, s, 'promasaji', e.target.value)}
                          style={{ width: '55px', textAlign: 'center' }} />
                      </td>
                      <td style={{ padding: '4px', textAlign: 'center' }}>
                        <input type="number" min="0" max="1" step="0.5" value={set.sp || ''}
                          onChange={e => updateRezultat(igrac.id, s, 'sp', e.target.value)}
                          style={{ width: '55px', textAlign: 'center' }} />
                      </td>
                      <td style={{ textAlign: 'center', fontWeight: '700', color: '#e94560' }}>{pune + cis}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="form-group">
              <label>MP</label>
              <input type="number" min="0" max="1" step="0.5" value={r.mp || ''}
                onChange={e => updateMP(igrac.id, e.target.value)}
                style={{ width: '70px' }} />
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div className="page-title" style={{ margin: 0 }}>Utakmice</div>
        {jeAdmin && (
          <button className="btn-primary"
            onClick={() => { setPrikaz(prikaz === 'unos' ? 'lista' : 'unos'); setKorak(1); }}>
            {prikaz === 'unos' ? '← Nazad' : '+ Nova utakmica'}
          </button>
        )}
      </div>

      {prikaz === 'lista' && (
        <>
          <div className="filter-bar">
            {SEZONE.map(s => (
              <button key={s} className={"filter-btn " + (filterSezona === s ? 'active' : '')}
                onClick={() => setFilterSezona(s)}>{s}</button>
            ))}
          </div>
          <div className="filter-bar">
            {['svi', ...KLUBOVI].map(k => (
              <button key={k} className={"filter-btn " + (filterKlub === k ? 'active' : '')}
                onClick={() => setFilterKlub(k)}>
                {k === 'svi' ? 'Svi klubovi' : k}
              </button>
            ))}
          </div>
          {filtrirane.length === 0 ? (
            <div className="card empty-state">
              <div className="icon">🎳</div>
              <p>Nema utakmica za odabranu sezonu</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {filtrirane.map(u => (
                <div key={u.id} className="card"
                  onClick={() => setAktivna({ strana: 'detaljiUtakmice', utakmicaId: u.id })}
                  style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', borderLeft: '4px solid ' + (u.domaci ? '#2ed573' : '#5378ff') }}>
                  <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <div style={{ textAlign: 'center', minWidth: '40px' }}>
                      <div style={{ fontSize: '11px', color: '#666688', textTransform: 'uppercase' }}>Kolo</div>
                      <div style={{ fontSize: '20px', fontWeight: '700', color: '#e94560' }}>{u.kolo}</div>
                    </div>
                    <div style={{ width: '1px', height: '40px', background: '#2a2a4a' }}></div>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '3px' }}>
                        <span style={{ fontSize: '11px', fontWeight: '700', padding: '2px 7px', borderRadius: '4px', background: u.domaci ? 'rgba(46,213,115,0.15)' : 'rgba(83,120,255,0.15)', color: u.domaci ? '#2ed573' : '#5378ff', border: '1px solid ' + (u.domaci ? 'rgba(46,213,115,0.4)' : 'rgba(83,120,255,0.4)') }}>
                          {u.domaci ? '🏠 Domaći' : '✈️ Gost'}
                        </span>
                        {u.takmicenje && u.takmicenje !== 'Premijer liga' && u.takmicenje !== 'Prva liga RS' && (
                          <span style={{ fontSize: '11px', color: '#ffc107' }}>{u.takmicenje}</span>
                        )}
                      </div>
                      <div style={{ fontSize: '15px', fontWeight: '600', color: '#fff' }}>
                        {u.domaci ? u.klub + ' vs ' + u.protivnik : u.protivnik + ' vs ' + u.klub}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666688', marginTop: '2px' }}>
                        {u.datum} • {u.ekipaUkupno} : {u.protivnikCunjevi || '?'} • MP: {u.ekipaMP} : {u.protivnikMP || '?'}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span className={"badge " + (u.ekipaBodovi === 2 ? 'badge-green' : u.ekipaBodovi === 1 ? 'badge-blue' : 'badge-red')}>
                      {u.ekipaBodovi === 2 ? 'Pobjeda' : u.ekipaBodovi === 1 ? 'Remi' : 'Poraz'} ({u.ekipaBodovi})
                    </span>
                    {jeAdmin && (
                      <button className="btn-danger btn-sm"
                        onClick={e => { e.stopPropagation(); if (window.confirm('Obrisati utakmicu?')) obrisiUtakmicu(u.id); }}>
                        Obrisi
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {prikaz === 'unos' && jeAdmin && (
        <div>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '24px' }}>
            {[{ br: 1, naziv: 'Osnovno' }, { br: 2, naziv: 'Sastav' }, { br: 3, naziv: 'Rezultati' }].map(k => (
              <div key={k.br} onClick={() => setKorak(k.br)}
                style={{ padding: '8px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', background: korak === k.br ? '#e94560' : korak > k.br ? '#1a1a2e' : '#16162a', color: korak >= k.br ? 'white' : '#666688', border: '1px solid ' + (korak === k.br ? '#e94560' : '#2a2a4a') }}>
                {k.br}. {k.naziv}
              </div>
            ))}
          </div>

          {korak === 1 && (
            <div className="card">
              <div className="section-title">Informacije o utakmici</div>
              <div className="form-row">
                <div className="form-group">
                  <label>Sezona</label>
                  <select value={forma.sezona} onChange={e => setForma({ ...forma, sezona: e.target.value })}>
                    {SEZONE.map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Datum</label>
                  <input type="date" value={forma.datum} onChange={e => setForma({ ...forma, datum: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Kolo</label>
                  <input type="number" placeholder="npr. 21" value={forma.kolo}
                    onChange={e => setForma({ ...forma, kolo: e.target.value })} style={{ width: '90px' }} />
                </div>
                <div className="form-group">
                  <label>Klub</label>
                  <select value={forma.klub} onChange={e => { setForma({ ...forma, klub: e.target.value }); setOdabraniIgraci([]); }}>
                    {KLUBOVI.map(k => <option key={k}>{k}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Protivnik</label>
                  <input placeholder="Naziv protivnika" value={forma.protivnik}
                    onChange={e => setForma({ ...forma, protivnik: e.target.value })} style={{ width: '180px' }} />
                </div>
                <div className="form-group">
                  <label>Cunjevi protivnika</label>
                  <input type="number" min="0" placeholder="npr. 3393" value={forma.protivnikCunjevi}
                    onChange={e => setForma({ ...forma, protivnikCunjevi: e.target.value })} style={{ width: '120px' }} />
                </div>
                <div className="form-group">
                  <label>Domaci/Gost</label>
                  <select value={forma.domaci ? 'domaci' : 'gost'} onChange={e => setForma({ ...forma, domaci: e.target.value === 'domaci' })}>
                    <option value="domaci">Domaci</option>
                    <option value="gost">Gost</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Takmicenje</label>
                  <select value={forma.takmicenje} onChange={e => setForma({ ...forma, takmicenje: e.target.value })}>
                    {TAKMICENJA.map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ marginTop: '20px' }}>
                <button className="btn-primary" onClick={() => setKorak(2)}>Dalje →</button>
              </div>
            </div>
          )}

          {korak === 2 && (
            <div>
              <div className="card" style={{ marginBottom: '16px' }}>
                <div className="section-title">Odaberi 6 igraca — {forma.klub} ({odabraniIgraci.length}/6)</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {igraciKluba.map(igrac => {
                    const odabran = !!odabraniIgraci.find(i => i.id === igrac.id);
                    return (
                      <div key={igrac.id} onClick={() => toggleIgrac(igrac)}
                        style={{ padding: '10px 18px', borderRadius: '6px', cursor: 'pointer', background: odabran ? '#e94560' : '#12122a', color: odabran ? 'white' : '#aaa', border: '1px solid ' + (odabran ? '#e94560' : '#2a2a4a'), fontWeight: odabran ? '600' : '400' }}>
                        {odabran ? '✓ ' : ''}{igrac.ime}
                      </div>
                    );
                  })}
                  {igraciKluba.length === 0 && <p style={{ color: '#666688' }}>Nema igraca u ovom klubu.</p>}
                </div>
              </div>

              <div className="card" style={{ marginBottom: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                  <div className="section-title" style={{ margin: 0 }}>Izmjene ({izmjene.length}/2)</div>
                  {izmjene.length < 2 && (
                    <button className="btn-primary btn-sm" onClick={dodajIzmjenu}>+ Dodaj izmjenu</button>
                  )}
                </div>
                {izmjene.length === 0 && <p style={{ color: '#666688', fontSize: '13px' }}>Nema izmjena.</p>}
                {izmjene.map(iz => (
                  <div key={iz.id} style={{ background: '#12122a', padding: '14px', borderRadius: '8px', marginBottom: '10px', border: '1px solid #2a2a4a' }}>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Igrac izlazi</label>
                        <select value={iz.igracVani} onChange={e => updateIzmjena(iz.id, 'igracVani', e.target.value)}>
                          <option value="">-- odaberi --</option>
                          {odabraniIgraci.map(i => <option key={i.id} value={i.id}>{i.ime}</option>)}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Igrac ulazi</label>
                        <select value={iz.igracUnutra} onChange={e => updateIzmjena(iz.id, 'igracUnutra', e.target.value)}>
                          <option value="">-- odaberi --</option>
                          {igraciKluba.filter(i => !odabraniIgraci.find(o => o.id === i.id)).map(i =>
                            <option key={i.id} value={i.id}>{i.ime}</option>
                          )}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Zamjena od hitca br. (1-120)</label>
                        <input type="number" min="1" max="120" value={iz.ukupnoHitac || ''}
                          onChange={e => updateIzmjena(iz.id, 'ukupnoHitac', parseInt(e.target.value))}
                          style={{ width: '90px' }} />
                        {iz.ukupnoHitac > 0 && (
                          <div style={{ fontSize: '11px', marginTop: '4px' }}>
                            <span style={{ color: '#e94560' }}>↑ izlazi: bacio {iz.ukupnoHitac - 1} kugli</span>
                            <span style={{ color: '#666688', margin: '0 6px' }}>•</span>
                            <span style={{ color: '#2ed573' }}>↓ ulazi: baca {120 - (iz.ukupnoHitac - 1)} kugli</span>
                          </div>
                        )}
                      </div>
                      <div className="form-group" style={{ justifyContent: 'flex-end' }}>
                        <label>&nbsp;</label>
                        <button className="btn-danger btn-sm"
                          onClick={() => setIzmjene(prev => prev.filter(i => i.id !== iz.id))}>
                          Ukloni
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button className="btn-secondary" onClick={() => setKorak(1)}>← Nazad</button>
                <button className="btn-primary" onClick={() => setKorak(3)}>Dalje →</button>
              </div>
            </div>
          )}

          {korak === 3 && (
            <div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '16px' }}>
                {sviIgraciUtakmice().map(igrac => renderFormaIgraca(igrac))}
              </div>

              <div style={{ background: '#12122a', border: '1px solid #2a2a4a', borderRadius: '8px', padding: '14px 18px', marginBottom: '16px' }}>
                <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', marginBottom: '10px' }}>
                  <span>Nasi cunjevi: <strong style={{ color: '#fff' }}>{ekipa.ukupno}</strong></span>
                  <span>Protivnik: <strong style={{ color: '#fff' }}>{ekipa.protivnikCunjevi || '?'}</strong></span>
                  <span>SP: <strong style={{ color: '#fff' }}>{ekipa.sp}</strong></span>
                  <span>MP igraci: <strong style={{ color: '#fff' }}>{ekipa.mp}</strong></span>
                  <span>Bonus MP: <strong style={{ color: '#ffc107' }}>{ekipa.bonusMP}</strong></span>
                </div>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: '16px' }}>
                    Ukupno MP: <strong style={{ color: '#fff', fontSize: '20px' }}>{ekipa.ukupnoMP}</strong>
                    <span style={{ color: '#2a2a4a', margin: '0 8px' }}>:</span>
                    <strong style={{ color: '#666688', fontSize: '20px' }}>{ekipa.mpProtivnik}</strong>
                  </span>
                  <span className={"badge " + (ekipa.bodovi === 2 ? 'badge-green' : ekipa.bodovi === 1 ? 'badge-blue' : 'badge-red')}
                    style={{ fontSize: '14px', padding: '4px 16px' }}>
                    {ekipa.bodovi === 2 ? 'Pobjeda' : ekipa.bodovi === 1 ? 'Remi' : 'Poraz'} ({ekipa.bodovi} boda)
                  </span>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button className="btn-secondary" onClick={() => setKorak(2)}>← Nazad</button>
                <button className="btn-primary" onClick={handleSacuvaj} style={{ fontSize: '15px', padding: '12px 32px' }}>
                  Sacuvaj utakmicu
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Utakmice;
